import { makeAutoObservable, reaction } from 'mobx';
import socketStore from './Socket';
import { toJS } from 'mobx';
class AuthStore {
  user: any = null;
  loading: boolean = true;
  allGroups: string[] = [];
  selectedGroup: string | null = null;

  constructor() {
    makeAutoObservable(this);
    this.checkUser();

    reaction(
      () => this.user?.profile?.sub,
      (sub) => {
        if (sub) {
          localStorage.setItem('userId', sub);

          socketStore.subscribeToUserUpdate();
          this.setSelectGroup(null);
          localStorage.removeItem('selectedGroup');
        }
      }
    );
  }

  getUserName() {
    return this.user?.user?.profile?.['cognito:username'] || '';
  }

  setSelectGroup(value: any) {
    this.selectedGroup = value;
  }
  setAllGroups(value: any) {
    this.allGroups = value;
  }

  checkUser(userData: any = null) {
    try {
      this.user = userData;
    } catch {
      this.user = null;
    } finally {
      this.loading = false;
    }
  }

  setUser(user: any) {
    this.user = user;
  }

  storeUserId() {
    if (this.user.user?.profile?.sub) {
      localStorage.setItem('myId', this.user.user?.profile?.sub || '');
    }
  }

  async logout() {
    try {
      this.user?.removeUser();
      localStorage.removeItem('userId');
      localStorage.removeItem('selectedGroup');

      const clientId = process.env.REACT_APP_CLIENT_ID!;
      const logoutUri = process.env.REACT_APP_LOGOUT_URI!;
      const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN!;

      const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;

      window.location.href = logoutUrl;
    } catch (error) {
      console.error('Error during signing out:', error);
      return false;
    }
  }
}

const authStore = new AuthStore();
export default authStore;
